export default __webpack_public_path__ + "static/media/10.09efa1c0.png";